import api from './client';

export const serviceTicketsApi = {
  list:        (params?: any) => api.get('/service-tickets', { params }),
  get:         (id: number)   => api.get(`/service-tickets/${id}`),
  create:      (data: any)    => api.post('/service-tickets', data),
  update:      (id: number, data: any) => api.put(`/service-tickets/${id}`, data),
  addPart:     (id: number, data: any) => api.post(`/service-tickets/${id}/parts`, data),
  removePart:  (id: number, itemId: number) => api.delete(`/service-tickets/${id}/parts/${itemId}`),
  addLabour:   (id: number, data: any) => api.post(`/service-tickets/${id}/labour`, data),
  removeLabour:(id: number, labourId: number) => api.delete(`/service-tickets/${id}/labour/${labourId}`),
  addNote:     (id: number, note: string) => api.post(`/service-tickets/${id}/notes`, { note }),
  diagnose:    (id: number, data: any) => api.post(`/service-tickets/${id}/diagnose`, data),
  sendQuote:   (id: number) => api.post(`/service-tickets/${id}/send-quote`, {}),
  reject:      (id: number, data: any) => api.post(`/service-tickets/${id}/reject`, data),
  complete:    (id: number, data: any) => api.post(`/service-tickets/${id}/complete`, data),
  payment:     (id: number, data: any) => api.post(`/service-tickets/${id}/payment`, data),
  quote:       (id: number, data: any) => api.post(`/service-tickets/${id}/quote`, data),
  approve:     (id: number, data: any) => api.post(`/service-tickets/${id}/approve`, data),
  changeStatus:(id: number, data: any) => api.post(`/service-tickets/${id}/status`, data),
  collect:     (id: number, data: any) => api.post(`/service-tickets/${id}/collect`, data),
  deliver:     (id: number, data: any) => api.post(`/service-tickets/${id}/deliver`, data),
};
